import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InstallationDetailsStore } from '@store';

@Component({
  selector: 'app-internal-hydraulic-details-overlay',
  templateUrl: './internal-hydraulic-details-overlay.component.html',
  styleUrls: ['./internal-hydraulic-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalHydraulicDetailsOverlayComponent implements OnInit {
  gatewaySerial: string;
  installationId: number;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.route.snapshot.queryParams['gatewaySerial'];
    this.installationId = +this.route.snapshot.params['id'];
  }
}
